// extracted by mini-css-extract-plugin
export default {"authorInfoContainer":"AuthorInfo_authorInfoContainer__R95DM","authorInfo":"AuthorInfo_authorInfo__A6Unn","userType":"AuthorInfo_userType__acsdv"};